export const sr = {
  // Header Navigation
  nav: {
    home: "ПОЧЕТНА",
    company: "XIAMEN TOWER TECH",
    sourcing: "УВОЗ",
    otherServices: "ОСТАЛЕ УСЛУГЕ",
    projects: "ПРОЈЕКТИ",
    blog: "БЛОГ",
    partners: "Партнери",
    contact: "КОНТАКТ"
  },
  
  // Hero Section
  hero: {
    title: "Увоз без ризика",
    titleHighlight: "без ризика",
    subtitle: "из Кине",
    description1: "Од фабрике до вашег складишта",
    description1Highlight: "– без изненађења.",
    description2: "Надгледамо сваки корак да ваша компанија може",
    description2Highlight: "да расте без бриге.",
    startSourcing: "Започните сада",
    learnMore: "Више информација"
  },

  // About Section
  about: {
    title: "О компанији Xiamen Tower Technology Co., Ltd.",
    description: "Основана 2019. године, Xiamen Tower Technology Co., Ltd. је водећа компанија за увоз-извоз и управљање ланцем снабдевања са седиштем у провинцији Фуџијен, Кина. Повезујемо међународна предузећа са поузданим кинеским произвођачима и обезбеђујемо квалитет, ефикасност и транспарентност на сваком кораку.",
    feature1Title: "Вишејезички Тим",
    feature1Description: "Говоримо енглески, немачки, шпански, словеначки и српски језик, обезбеђујући јасну комуникацију током целог процеса.",
    feature2Title: "Глобална Подршка у Испоруци",
    feature2Description: "Помажемо клијентима широм света уз ефикасну логистику, испоруку и комплетна end-to-end решења.",
    feature3Title: "Мрежа Проверених Произвођача",
    feature3Description: "Сарађујемо искључиво са поузданим и аудитираним произвођачима ради сталног квалитета."
  },

  // Services Section
  services: {
    title: "Наше услуге",
    description: "Пружамо свеобухватна решења за ваше потребе увоза и производње у Кини.",
    subtitle: "Подржавамо вас у једној или више фаза процеса.",
    mainTitle: "Услуге увоза",
    sourcingTitle: "Увоз",
    otherServicesTitle: "Додатне услуге увоза",
    sourcingDescription1: "Преузимамо цео процес увоза: од избора идеалног добављача и развоја производа до строгих контрола квалитета и оптимизоване логистике.",
    sourcingDescription2: "Нисмо само посредник – ваш смо стратешки партнер у глобалном увозу, са ефикасношћу, уштедом и безбедношћу у сваком пројекту.",
    otherServicesDescription1: "Нудимо допунске услуге које омогућавају успешну реализацију међународних пројеката.",
    otherServicesDescription2: "Од стратешког саветовања до уласка на нова тржишта – ваш поуздан партнер за глобални раст.",
    hideDetails: "Сакриј Детаље",
    showInfo: "+ ВИШЕ ИНФО",
    moreInfo: "Више информација",
    process: "Наш процес",
    benefits: "Кључне предности",
    supplierSelection: {
      title: "Избор Добављача",
      description: "Идентификујемо и верификујемо поуздане произвођаче у Кини који испуњавају ваше захтеве и стандарде квалитета.",
      steps: {
        step1: "Анализа захтева и истраживање тржишта",
        step2: "Идентификација и претходна селекција квалификованих добављача",
        step3: "Посете фабрикама и техничке процене",
        step4: "Верификација и сертификација добављача"
      },
      benefits: {
        benefit1: "Приступ провереним премијум произвођачима",
        benefit2: "Смањен ризик кроз строгу проверу",
        benefit3: "Краће време квалификације добављача"
      }
    },
    productDevelopment: {
      title: "Развој Производа",
      description: "Ваша идеја постаје конкурентан производ — од концепта до серијске производње — уз највише стандарде и гаранције.",
      steps: {
        step1: "Техничке спецификације и захтеви дизајна",
        step2: "Израда прототипа и узорака",
        step3: "Техничка оптимизација и анализа трошкова",
        step4: "Припрема производње и развој алата"
      },
      benefits: {
        benefit1: "Дизајн усмерен на лакшу производњу",
        benefit2: "Брже излажење на тржиште",
        benefit3: "Континуирано унапређење према повратним информацијама тржишта"
      }
    },
    qualityControl: {
      title: "Контрола Квалитета",
      description: "Надгледамо сваку фазу производње како бисмо обезбедили усаглашеност, доследност и изузетан квалитет у свакој серији.",
      steps: {
        step1: "Инспекција материјала и провере пре производње",
        step2: "Надзор током производње (DUPRO)",
        step3: "Завршна инспекција пре испоруке (PSI)",
        step4: "Детаљни извештаји са фото документацијом"
      },
      benefits: {
        benefit1: "Рано откривање проблема са квалитетом",
        benefit2: "Мање повраћаја и рекламација",
        benefit3: "Доследан ниво квалитета у свим серијама"
      }
    },
    logisticsManagement: {
      title: "Логистичко Управљање",
      description: "Координишемо цео ланац снабдевања за ефикасан и сигуран увоз из Кине у ваше складиште.",
      steps: {
        step1: "Избор и преговори са логистичким партнерима",
        step2: "Царињење и извозна документација",
        step3: "Консолидација контејнера и оптимизација транспорта",
        step4: "Праћење у реалном времену до финалне испоруке"
      },
      benefits: {
        benefit1: "Оптимизовани трошкови транспорта",
        benefit2: "Брже испоруке са експрес опцијама",
        benefit3: "Потпуно осигурање пошиљке и покривеност терета"
      }
    }
  },

  // Service Process & Additional Services
  serviceProcess: {
    title: "Наш процес увоза:",
    steps: [
      "Истраживање тржишта и идентификација добављача",
      "Преговарање о ценама и уговорним условима",
      "Обезбеђивање квалитета и управљање роковима",
      "Координација логистике од краја до краја"
    ]
  },

  additionalServices: {
    title: "Додатне услуге:",
    items: [
      "Саветовање за улазак на тржиште",
      "Подршка прилагођавања производа", 
      "Помоћ за регулаторну усклађеност",
      "Развој дугорочних партнерстава"
    ]
  },

  // Service Details (for expanded info sections)
  serviceDetails: {
    supplierSelection: {
      fullDescription: "Наш свеобухватан процес избора добављача укључује темељне провере позадине, ревизије фабрика, преглед сертификата квалитета и процене производних капацитета. Проверавамо пословне дозволе, извозне квалификације и претходне референце клијената да обезбедимо партнерство са поузданим произвођачима.",
      benefits: [
        "Верификација и ревизије фабрика",
        "Провере сертификата квалитета", 
        "Процена производних капацитета",
        "Процена финансијске стабилности",
        "Валидација претходних референци клијената"
      ]
    },
    productDevelopment: {
      fullDescription: "Од концепта до производње, водимо ваше путовање развоја производа. Наш тим ради са произвођачима да створи прототипове, усаврши дизајн, изведе тестирања и обезбеди да ваш производ испуњава међународне стандарде пре почетка масовне производње.",
      benefits: [
        "Развој прототипова",
        "Оптимизација дизајна",
        "Тестирање и валидација квалитета", 
        "Усклађеност са међународним стандардима",
        "Планирање временских рокова производње"
      ]
    },
    qualityControl: {
      fullDescription: "Наш тим за контролу квалитета спроводи предпроизвођачке инспекције, надгледање током процеса и финалне инспекције производа. Користимо међународне стандарде квалитета и пружамо детаљне извештаје са фотографијама да обезбедимо да ваши производи испуњавају спецификације.",
      benefits: [
        "Предпроизвођачке инспекције",
        "Надгледање квалитета током процеса",
        "Финална инспекција производа",
        "Детаљни извештаји о квалитету", 
        "Усклађеност са међународним стандардима"
      ]
    },
    logisticsManagement: {
      fullDescription: "Координишемо цео логистички ланац – од преузимања робе у фабрици до испоруке у ваше складиште. Ово укључује извозну документацију, царињење, аранжмане транспорта, осигурање и праћење у реалном времену током целог путовања.",
      benefits: [
        "Руковање извозном документацијом",
        "Помоћ при царињењу",
        "Координација транспорта и терета",
        "Осигурање пошиљке",
        "Праћење пошиљке у реалном времену"
      ]
    }
  },

  // Global Reach Section
  globalReach: {
    title: "Глобални Досег",
    description: "Са нашом снажном мрежом добављача и локалном експертизом у Кини, подржавамо клијенте широм света кроз поуздану набавку, инспекцију квалитета и комплетно управљање пројектима у различитим индустријама.",
    feature1Title: "🌍 Подршка широм Света",
    feature1Description: "Подршка клијентима у свим главним светским регионима.",
    feature2Title: "🤝 Интернационални Клијенти",
    feature2Description: "Верују нам компаније из Европе, Америке, Азије и других региона.",
    feature3Title: "🏭 Проверена Мрежа Добављача",
    feature3Description: "Сарађујемо само са аудитираним и поузданим произвођачима.",
    feature4Title: "📦 End-to-End Управљање Пројектима",
    feature4Description: "Од одабира добављача до коначне испоруке — координирамо сваки корак."
  },

  // Projects Section
  projects: {
    title: "Категорије Производа",
    description: "Истражите наш разноврсни спектар категорија производа и откријте квалитетна решења која можемо набавити за ваше пословне потребе.",
    subtitle: "С чим радимо",
    viewDetails: "Погледајте Детаље",
    viewProducts: "Погледајте Производе",
    hideProducts: "Сакриј",
    contactForDetails: "За детаљне информације о производима и цене, контактирајте наш тим преко формулара испод.",
    lookingForSpecific: "Тражите Нешто Специфично?",
    lookingDescription: "Наши експерти за набавку могу вам помоћи да пронађете праве произвођаче и добављаче у Кини за било коју категорију производа или прилагођене захтеве које можда имате.",
    contactTeam: "Контактирајте Наш Тим",
    viewAllCategories: "Погледајте Све Категорије",
    allProjects: "Сви Пројекти",
    startYourProject: "Започните Ваш Пројекат",
    categories: {
      electronics: "ЕЛЕКТРОНИКА",
      machinery: "МАШИНЕ", 
      tools: "АЛАТИ",
      packaging: "АМБАЛАЖА",
      consumer: "ПОТРОШНА РОБА",
      textiles: "ТЕКСТИЛ",
      apparel: "ОДЕЋА И ПРОИЗВОДИ ЗА БЕБЕ"
    }
  },

  // Products (translated from mockData)
  products: {
    textiles: {
      technicalFabrics: {
        name: "Техничке тканине",
        description: "Ватроотпорне, водоотпорне и антибактеријске тканине за специјалне намене."
      },
      sustainableClothing: {
        name: "Одржива одећа",
        description: "Органски памук, бамбусова влакна и рециклирани полиестер."
      },
      homeTextiles: {
        name: "Кућни текстил",
        description: "Постељина, завесе, столњаци и украсне тканине."
      },
      workwear: {
        name: "Радна одећа и униформе", 
        description: "Професионална одећа, сигурносни прслуци, кецеље и корпоративне униформе."
      },
      cottonProducts: {
        name: "Памучни производи",
        description: "Мајице, пешкири, чарапе и свакодневна одећа."
      }
    },
    apparel: {
      babyProducts: {
        name: "Производи и додаци за бебе",
        description: "Бебина одећа, пелене, флашице, колица, ауто-седишта и сигурносни додаци."
      },
      kidsClothing: {
        name: "Дечја одећа и обућа",
        description: "Школске униформе, патике и сезонске колекције."
      },
      adultsFashion: {
        name: "Мода за одрасле",
        description: "Свакодневна, пословна и спортска одећа, као и модни додаци."
      },
      maternitywear: {
        name: "Трудничка и одећа за дојење", 
        description: "Удобна одећа за труднице и дојиље, као и за период након порођаја."
      },
      seasonalCollections: {
        name: "Сезонске колекције",
        description: "Зимска, летња и празнична тематска одећа за све узрасте."
      },
      footwearAccessories: {
        name: "Обућа и додаци",
        description: "Ципеле, чизме, ташне, каишеви и модни накит."
      }
    },
    consumer: {
      smartAppliances: {
        name: "Паметни кућни апарати",
        description: "Роботски усисивачи, прочишћивачи ваздуха и паметни термостати."
      },
      furniture: {
        name: "Равно упакован намештај",
        description: "Намештај за склапање, столице и системи за складиштење."
      },
      kitchenGadgets: {
        name: "Кухињски направи", 
        description: "Фритезе, електрични котлови, кућни роботи и иновативни алати."
      },
      fitnessAccessories: {
        name: "Фитнес додаци",
        description: "Простирке за јогу, еластичне траке, флаше и опрема за вежбање."
      },
      phoneAccessories: {
        name: "Додаци за телефон",
        description: "Футроле, бежични пуњачи, слушалице и држачи."
      }
    },
    tools: {
      measuring: {
        name: "Прецизни мерни инструменти",
        description: "Дигитални мерни уређаји, микрометри и индикатори."
      },
      toolSets: {
        name: "Индустријски сетови алата",
        description: "Комплети механичарских и електричарских алата за професионалну употребу."
      },
      powerAccessories: {
        name: "Додаци за електричне алате", 
        description: "Бургије, тестере и брусни дискови различитих величина."
      },
      handTools: {
        name: "Ручни алати",
        description: "Кључеви, шрафцигери, клешта и инбус кључеви."
      },
      safetyEquipment: {
        name: "Безбедносна опрема",
        description: "Заштитне наочаре, рукавице, кацеге и опрема за слух."
      }
    },
    packaging: {
      packagingMachines: {
        name: "Аутоматске машине за паковање",
        description: "Опрема за паковање хране, фармацеутских и потрошних производа."
      },
      labelingSystems: {
        name: "Системи етикетирања и штампања",
        description: "Машине за етикете и кодирање производа."
      },
      sealingEquipment: {
        name: "Опрема за затварање", 
        description: "Топлотни и вакуумски затварачи и диспенсери траке."
      },
      corrugatedBoxes: {
        name: "Таласасте кутије и картони",
        description: "Штампане транспортне кутије различитих величина."
      },
      protectivePackaging: {
        name: "Заштитна амбалажа",
        description: "Паковања од пенастих материјала, јастучићи и заштитни омоти."
      }
    },
    electronics: {
      solarPanels: {
        name: "Системи соларних панела",
        description: "Високоeфикасни моно и поликристални панели за домаћу и комерцијалну примену."
      },
      electricBikes: {
        name: "Електрични бицикли и скутери", 
        description: "Е-бицikli и паметни скутери са ГПС-ом и дуготрајним батеријама."
      },
      ledLights: {
        name: "ЛЕД соларне уличне лампе",
        description: "Соларни системи са сензорима покрета и даљинским управљањем."
      },
      powerBanks: {
        name: "Преносне соларне батерије",
        description: "Пуњачи велике снаге за спољашњу и хитну употребу."
      },
      smartHome: {
        name: "Паметни кућни уређаји",
        description: "WiFi термостати, утичнице и системи за гласовну контролу."
      }
    },
    machinery: {
      cncMachining: {
        name: "ЦНЦ центри за обраду",
        description: "3–5 осна опрема за производњу и прототипирање."
      },
      conveyor: {
        name: "Индустријски транспортни системи", 
        description: "Аутоматизоване траке за паковање и руковање материјалима."
      },
      hydraulicPress: {
        name: "Хидрауличне пресе",
        description: "Пресе за обликовање метала и индустријску употребу."
      },
      pneumaticTools: {
        name: "Пнеуматски алати и компоненте",
        description: "Компресори, цилиндри и прикључци."
      },
      weldingEquipment: {
        name: "Заваривачка опрема",
        description: "MIG/TIG апарати, плазма резачи и додатна опрема."
      }
    }
  },

  // Blog Section
  blog: {
    title: "Најновије Кинеске ЕКСПО Вести и Увиди у Индустрију",
    description: "Останите у току са најновијим трендовима, вестима и увидима из кинеске производне и извозне индустрије.",
    chinaExpoNews: "Најновије Кинеске ЕКСПО Вести",
    industryInsights: "Увиди у Индустрију",
    industryInsightsDescription: "Тржишни трендови, стратегије набавке и анализе које обликују глобалну производњу.",
    dailyArticles: "Дневне Вести",
    dailyArticlesSubtext: "Свеже вести и увиди из света трговине – сваког дана",
    readMore: "Прочитај Више",
    viewAllArticles: "Сви Чланци",
    lastUpdated: "Последње Ажурирано",
    refreshAll: "Освежи Све",
    updating: "Ажурирам...",
    autoUpdatesMonthly: "Аутоматска месечна ажурирања",
    liveFeeds: "Уживо индустријски фидови",
    expoUpdates: "Кинеска ЕКСПО Ажурирања",
    expoDescription: "Најновије вести са Кинеског међународног сајма увоза (CIIE), Кантонски Сајам и важни трговински догађаји"
  },

  // Contact Section
  contact: {
    title: "Контактирајте Нас",
    description: "Спремни да започнете ваше путовање набавке? Ступите у контакт са нашим тимом за прилагођена решења.",
    alternateTitle: "Останимо у контакту!",
    alternateDescription: "Ако имате било каква питања или упите о нашим услугама, молимо пошаљите нам контакт формулар или се обратите директно нашој канцеларији.",
    fullName: "Пуно Име",
    email: "Емаил Адреса",
    company: "Компанија",
    subject: "Предмет",
    message: "Порука",
    yourName: "Ваше Име",
    yourEmail: "Ваш Емаил",
    companyName: "Име Компаније",
    tellUs: "Реците нам о захтевима вашег пројекта...",
    attachFiles: "Приложите датотеке",
    filesSelected: "датотека(е) изабрано",
    acceptPrivacy: "Прихватам политику приватности",
    sendMessage: "Пошаљи Поруку",
    messageSent: "Порука је успешно послата!",
    responseTime: "Одговорићемо вам у року од 24 сата.",
    validationError: "Грешка при валидацији",
    fillRequiredFields: "Молимо попуните сва обавезна поља.",
    invalidEmail: "Молимо унесите важећу адресу е-поште.",
    errorTitle: "Грешка",
    errorMessage: "Слање поруке није успело. Покушајте поново или нас контактирајте директно на office@towertech-xm.com",
    phoneLabel: "Телефон",
    emailLabel: "Емаил",
    locationLabel: "Локација",
    foundedLabel: "Основана",
    ourOffice: "Наша Канцеларија",
    howHelp: "Како можемо да вам помогнемо?",
    requirementsDetail: "Молимо објасните ваше захтеве што је детаљније могуће. Можете нам послати и било коју релевантну документацију (планове, детаље), ако желите. Све упите ће наш тим брзо обрадити и одговорити.",
    attachDocumentation: "Да ли треба да приложите документацију вашег пројекта?",
    privacyAccept: "Прочитао/ла сам и прихватам",
    privacyPolicies: "Политику приватности",
    contactForm: "Пошаљите нам поруку преко нашег контакт формулара"
  },

  // Footer
  footer: {
    description: "Ваш поуздан партнер за увоз без ризика из Кине. Повезујемо предузећа широм света са поузданим произвођачима и обезбеђујемо квалитет на сваком кораку.",
    quickLinks: "Брзе Везе",
    home: "Почетна",
    about: "О Нама", 
    services: "Услуге",
    projects: "Пројекти",
    blog: "Блог",
    contact: "Контакт",
    legal: "Правно",
    termsOfService: "Услови Коришћења",
    privacyPolicy: "Правила Приватности",
    cookiePolicy: "Правила Колачића",
    gdprCompliance: "ГДПР Усклађеност",
    languagesWeSpeak: "Језици Које Говоримо",
    rights: "Сва права задржана.",
    adminPanel: "Админ Панел",
    scrollToTop: "Иди на врх"
  },

  // Legal Pages
  legal: {
    goBack: "Назад",
    lastUpdated: "Последње ажурирање: Децембар 2024",
    
    // Terms of Service
    terms: {
      title: "Услови коришћења",
      section1: {
        title: "1. Прихватање услова",
        content: "Приступањем и коришћењем веб сајта Xiamen Tower Technology Co., Ltd. (towertech-xm.com), слажете се да будете везани овим Условима коришћења и свим применљивим законима и прописима. Ако се не слажете са било којим од ових услова, забрањено вам је коришћење овог сајта."
      },
      section2: {
        title: "2. Информације о компанији",
        company: "Компанија: Xiamen Tower Technology Co., Ltd.",
        address: "Адреса: Провинција Фуџијан, Кина",
        phone: "Телефон: +86 15381939338",
        email: "Е-пошта: office@towertech-xm.com",
        founded: "Основана: 2019",
        services: "Xiamen Tower Technology Co., Ltd. пружа услуге увоза-извоза и набавке производа, специјализујући се за повезивање међународних предузећа са кинеским произвођачима. Наше услуге укључују:"
      },
      section3: {
        title: "3. Лиценца за коришћење",
        content: "Дозвољено је привремено преузимање једне копије материјала са веб сајта Xiamen Tower Technology за лично, некомерцијално привремено разгледање. Ово је издавање лиценце, а не пренос власништва."
      },
      section4: {
        title: "4. Одрицање од одговорности",
        content: "Материјали на веб сајту Xiamen Tower Technology се пружају 'како јесу'. Xiamen Tower Technology не даје никакве гаранције, експлицитне или имплицитне, и овим одбацује и поништава све остале гаранције."
      },
      section5: {
        title: "5. Ограничења",
        content: "Ни у ком случају Xiamen Tower Technology или њени добављачи неће бити одговорни за било какву штету (укључујући, али не ограничавајући се на штету због губитка података или профита, или због прекида пословања) која произилази из коришћења или немогућности коришћења материјала на веб сајту Xiamen Tower Technology."
      },
      section6: {
        title: "6. Контакт информације",
        content: "За сва питања о овим Условима коришћења, контактирајте нас на office@towertech-xm.com или +86 15381939338."
      }
    },
    
    // Privacy Policy
    privacy: {
      title: "Политика приватности",
      section1: {
        title: "1. Информације које прикупљамо",
        intro: "Xiamen Tower Technology прикупља информације које нам директно достављате, као што је када:",
        items: [
          "Попуњавате наше контакт форме",
          "Захтевате понуде или информације о нашим услугама",
          "Претплаћујете се на наш билтен",
          "Комуницирате са нама путем е-поште или телефона",
          "Посећујете наш веб сајт (преко колачића и сличних технологија)"
        ]
      },
      section2: {
        title: "2. Како користимо ваше информације",
        content: "Користимо информације које прикупљамо да бисмо пружили, одржавали и побољшавали наше услуге, одговарали на ваше упите, слали вам маркетинг комуникације (уз вашу сагласност) и испуњавали правне обавезе."
      },
      section3: {
        title: "3. Дељење информација",
        content: "Не продајемо, размењујемо нити на други начин преносимо ваше личне информације трећим странама без ваше сагласности, осим како је описано у овој политици или како захтева закон."
      },
      section4: {
        title: "4. Безбедност података",
        content: "Спроводимо одговарајуће безбедносне мере за заштиту ваших личних информација од неовлашћеног приступа, измене, откривања или уништавања."
      },
      section5: {
        title: "5. Ваша права",
        content: "Имате право да приступите, ажурирате или обришете своје личне информације. Такође можете да се одјавите од примања маркетинг комуникација у било ком тренутку."
      },
      section6: {
        title: "6. Контактирајте нас",
        content: "Ако имате било каква питања о овој Политици приватности, контактирајте нас на office@towertech-xm.com."
      }
    },
    
    // Cookie Policy
    cookies: {
      title: "Политика колачића",
      section1: {
        title: "1. Шта су колачићи",
        content: "Колачићи су мале текстуалне датотеке које се чувају на вашем уређају када посетите наш веб сајт. Помажу нам да вам пружимо боље искуство прегледања."
      },
      section2: {
        title: "2. Врсте колачића које користимо",
        essential: "Основни колачићи: Потребни за правилно функционисање веб сајта",
        analytics: "Аналитички колачићи: Помажу нам да разумемо како посетиоци користе наш веб сајт",
        preferences: "Колачићи подешавања: Памте ваша подешавања и преференције"
      },
      section3: {
        title: "3. Управљање колачићима",
        content: "Можете контролисати и управљати колачићима кроз подешавања вашег прегледача. Имајте на уму да онемогућавање одређених колачића може утицати на функционалност веб сајта."
      }
    },
    
    // GDPR Compliance
    gdpr: {
      title: "ГДПР усклађеност",
      section1: {
        title: "1. Заштита података",
        content: "Xiamen Tower Technology је посвећена заштити ваших личних података у складу са Општом уредбом о заштити података (GDPR)."
      },
      section2: {
        title: "2. Ваша права под ГДПР",
        rights: [
          "Право приступа вашим личним подацима",
          "Право исправке нетачних података",
          "Право брисања ваших података",
          "Право ограничавања обраде",
          "Право преносивости података",
          "Право приговора на обраду"
        ]
      },
      section3: {
        title: "3. Контактирајте нашег службеника за заштиту података",
        content: "За сва питања везана за ГДПР, контактирајте нашег службеника за заштиту података на office@towertech-xm.com."
      }
    }
  },

  // FAQ Section
  faq: {
    title: "Чешће постављана питања",
    subtitle: "Све што треба да знате о успешном увозу",
    takeAdvantage: "Искористите предности увоза.",
    helpOptimize: "Помажемо да оптимизујете трошкове и минимизујете ризике.",
    successfulImporting: "Успешан увоз почиње стручњацима и поузданим процесима.",
    startProject: "Започните ваш пројекат",
    questions: [
      {
        question: "У којим регионима пружате услуге увоза?",
        answer: "Налазимо се у Кини и подржавамо клијенте широм света кроз набавку, управљање добављачима, контролу квалитета и међународну испоруку из Кине."
      },
      {
        question: "Да ли нудите развој производа по мери?",
        answer: "Да. Подршка од концепта до серијске производње уз контролу квалитета у свакој фази."
      },
      {
        question: "Како гарантујете квалитет?",
        answer: "Систематске фабричке ревизије и контрола квалитета за сваки производни циклус; тим на терену у Кини."
      },
      {
        question: "Да ли обезбеђујете логистику?",
        answer: "Да. Извоз, царињење, документација и испорука до вашег складишта – све на једном месту."
      }
    ]
  },

  // Languages
  languages: {
    en: "English",
    es: "Español",
    de: "Deutsch", 
    sl: "Slovenščina",
    sr: "Српски"
  },

  // Common UI Elements
  ui: {
    backButton: "Назад",
    loading: "Учитавање...",
    error: "Грешка",
    success: "Успех",
    close: "Затвори",
    save: "Сачувај",
    cancel: "Откажи",
    delete: "Обриши",
    edit: "Уреди",
    view: "Погледај",
    hide: "Сакриј",
    show: "Прикажи",
    more: "Више",
    less: "Мање",
    keyBenefits: "Кључне предности:"
  },

  // Cookie Consent Banner
  cookies: {
    bannerTitle: "Користимо колачиће",
    bannerDescription: "Користимо колачиће за побољшање вашег искуства претраживања, анализу саобраћаја на сајту и персонализацију садржаја. Кликом на \"Прихвати све\" пристајете на употребу колачића.",
    acceptAll: "Прихвати све",
    declineOptional: "Одбиј опционе"
  },

  // Међународни партнери
  partners: {
    title: "Наши међународни партнери",
    subtitle: "Поуздани сарадници који проширују наш домет и подржавају клијенте на кључним глобалним тржиштима.",
    websiteLabel: "Веб сајт",
    becomePartner: "Заинтересовани сте да постанете званични дистрибутивни партнер?",
    contactCta: "Ступите у контакт",
    valsol: {
      tagline: "Дистрибутивни партнер за Чиле",
      description: "Званични партнер компаније Xiamen Tower Technology Co., Ltd. за Чиле.\nСпецијализован за директну набавку и увоз из Кине, са фокусом на поуздане ланце снабдевања и подршку локалним клијентима и тржишту."
    }
  }
};